import React from "react";

import { STRINGS } from "../utils/string";

export default function ActionItemProvider({ item }) {
  return (
    <>
      <div className="truncate font-bold">
        {item?.name || item?.onCaseName || STRINGS.NO_PROVIDER_NAME}
      </div>
      <div className="mb-1 truncate text-ellipsis">
        <span className="font-bold">{STRINGS.CLIENT_COUNT}: </span>
        {item?.clientCount ? item?.clientCount : STRINGS.NO_CLIENT_NAME}
      </div>
    </>
  );
}
